import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const AdminBootcampDashboard = () => {

  const navigate = useNavigate();

  return (

    <div className="p-6">

      {/* HEADER */}

      <div className="flex items-center gap-3 mb-6">

        <button
          onClick={() => navigate("/admin/dashboard")}
          className="flex items-center gap-2 text-muted-foreground hover:text-primary"
        >
          <Icon name="ArrowLeft" size={18} />
          Back
        </button>

      </div>


      <h1 className="text-2xl font-bold mb-6">
        Bootcamp Management
      </h1>


      <div className="flex gap-4">

        <button
          onClick={() => navigate("/admin/bootcamp/create")}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Create Bootcamp
        </button>

        <button
          onClick={() => navigate("/admin/bootcamp/list")}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          View Bootcamps
        </button>

        <button
          onClick={() => navigate("/admin/bootcamp/registrations")}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Registrations
        </button>

      </div>

    </div>
  );
};

export default AdminBootcampDashboard;